export enum ActivityTypes {
  ACTIVE = '11d0927c-0746-11ed-b939-0242ac120002',
  INACTIVE = '11d094fc-0746-11ed-b939-0242ac120002',
}
